import moment from "moment";

export const columns = [
  //  startTime: '', // 值班开始时间
  //         endTime: '', // 值班结束时间
  //         dutyType: '',// 值班类型
  //         dutyPersonnel: '',// 值班人员
  //         dutySituation: '',// 值班情况
  //         dealtSituation: '', // 值班办结情况
  //         shiftLeader: '',// 值班领导
  //         completionSituation: '' // 值班待办情况
  {
    title: '值班开始时间',
    key: 'startTime',
    align: 'center',
    render: (h, params) => {
      return h('div', [
        h('span', moment(params.row.startTime).format('YYYY-MM-DD HH:mm:ss'))
      ],)
    }
  },
  {
    title: '值班结束时间',
    key: 'endTime',
    align: 'center',
    render: (h, params) => {
      return h('div', [
        h('span', moment(params.row.endTime).format('YYYY-MM-DD HH:mm:ss'))
      ],)
    }
  },
  // { title: '区县', key: 'areaName', align: 'center' },
  { title: '值班类型', key: 'dutyTypeName', align: 'center' },
  { title: '值班人员', key: 'dutyPersonnel', align: 'center' },
  { title: '值班情况', key: 'dutySituation', align: 'center', width: 200, tooltip: true, },
  { title: '值班办结情况', key: 'dealtSituation', align: 'center', width: 200, tooltip: true, },
  { title: '值班领导', key: 'shiftLeader', align: 'center' },
  { title: '值班待办情况', key: 'completionSituation', align: 'center', width: 200, tooltip: true, },
]
